module.exports = __webpack_public_path__ + "img/HM.e32ae476.png";